import t from "@/lang/lang";
import { FieldErrors } from "@/shared/components/field/field";
import { Field, FieldLabel } from "@/shared/components/ui/field";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import { useFieldErrors } from "@/shared/lib/errors/err-validation-failed-context";
import { NullUUID } from "@/shared/lib/utilities/uuid";
import { ServiceObjectName } from "@/services/backend/customers/components/service-object-name";
import { ServiceObjectReference } from "@/services/backend/documents/types/service-object-references-base";

/**
 * ScopeOfWorkServiceObjectField selects the service object of a scope of
 * work among the serviceObjects of its document, or none.
 */
export function ScopeOfWorkServiceObjectField({
  serviceObjects,
  value,
  onValueChange,
  fieldName,
  disabled,
}: {
  serviceObjects: ServiceObjectReference[];
  value: string;
  onValueChange: (serviceObjectId: string) => void;
  fieldName: string;
  disabled: boolean;
}) {
  const { errors, invalid, reset } = useFieldErrors(fieldName);

  return (
    <Field data-invalid={invalid || undefined} className="lg:col-span-2">
      <FieldLabel>{t("Serviceobjekt")}</FieldLabel>
      <Select
        value={value || NullUUID}
        onValueChange={(serviceObjectId) => {
          reset();
          onValueChange(serviceObjectId);
        }}
        disabled={disabled}
      >
        <SelectTrigger aria-invalid={invalid || undefined}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectItem value={NullUUID}>{t("Kein Serviceobjekt")}</SelectItem>
            {serviceObjects.map((so: ServiceObjectReference) => (
              <SelectItem key={so.serviceObjectId} value={so.serviceObjectId}>
                <ServiceObjectName id={so.serviceObjectId} />
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
      <FieldErrors errors={errors} />
    </Field>
  );
}
